export const validateFileSize = (size: number, maxSizeInMB: number) => {
  return size / (1024 * 1024) <= maxSizeInMB
}
